/**
 * Formate video, categorii de produs și tiere.
 * Formatul se alege primul în wizard, fără re-încadrare ulterioară (spec-overview §6).
 */
export const VIDEO_FORMATS = ['9:16', '1:1', '16:9'];
export const VIDEO_FORMAT_META = {
    '9:16': { format: '9:16', label: 'Vertical (Reels/TikTok/Shorts)', orientation: 'portrait', aspectRatio: 9 / 16 },
    '1:1': { format: '1:1', label: 'Pătrat (feed)', orientation: 'square', aspectRatio: 1 },
    '16:9': { format: '16:9', label: 'Orizontal (YouTube)', orientation: 'landscape', aspectRatio: 16 / 9 },
};
export function isVideoFormat(value) {
    return typeof value === 'string' && VIDEO_FORMATS.includes(value);
}
/** Cele două categorii de produs (aceeași mașinărie tehnică, structuri narative diferite). */
export const PRODUCT_CATEGORIES = ['organic', 'reclame'];
/** Cele două tiere comerciale. */
export const PRODUCT_TIERS = ['premium', 'ultra'];
//# sourceMappingURL=video.js.map